import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"; // ✅ Import useNavigate
import useAuthStore from "../../store/useAuthStore";
import FormInput from "../UIElements/FormInput";
import Button from "../UIElements/Button";
import {plainColors} from "../UIElements/Elements";
import backGroundImage from "../Assets/loginbck.jpg"
const LoginForm = () => {
    const {login, user, error, loading} = useAuthStore();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate(); // ✅ Initialize navigation

    const handleLogin = async (e) => {
        e.preventDefault();
        await login(email, password);
    };

    // ✅ Redirect to Dashboard if login is successful
    useEffect(() => {
        if (user) {
            navigate("/dashboard"); // ✅ Redirect user after login
        }
    }, [user, navigate]);

    return (
        <div className="flex justify-center items-center flex-col h-screen   bg-cover bg-center" style={{ backgroundImage: `url(${backGroundImage})` }}>
            <div className={'flex justify-center items-center flex-col w-[100vw] h-[100vh]  bg-opacity-[30%] bg-gradient-to-t from-blue-950/70 to-[#010f26]  '}  >
                <div className="w-96 bg-white/90 p-6 rounded-lg shadow-md max-lg:w-[92vw]">
                    <h2 className="text-2xl font-bold text-center mb-4">Login</h2>
                    {error && <p className="text-red-500 text-center">{error}</p>}
                    <form onSubmit={handleLogin}>
                        <FormInput type="email" placeholder="Email" value={email}
                                   onChange={(e) => setEmail(e.target.value)}/>
                        <FormInput type="password" placeholder="Password" value={password}
                                   onChange={(e) => setPassword(e.target.value)}/>
                        <Button text={loading ? "Logging in..." : "Login"} disabled={loading}
                                color={plainColors.success}/>
                    </form>
                </div>
                <a href={'/signup'} className={'text-white mt-[2vh] underline'}>Dont have an account?</a>
            </div>
        </div>
    );
};

export default LoginForm;
